import React from 'react'
import classes from './Faq.module.css'
import Navbar from '../Components/Navbar';
import Card from '../Components/Card';

const Faq = () => {



  const faqs = [
    {
      question: "What is The Funny Bone Service?",
      answer:
        "Funny Bone service offers access to a variety of comedy content including performances by comedy artists, stand-up comedians, and mimicry artists. Users can enjoy jokes, stand-up routines, recorded stage performances, and international comedy acts.",
    },
    {
      question: "Is this available to all customers?",
      answer: "Yes, Funny Bone service is accessible to both postpaid and prepaid customers of MTN.",
    },
    {
      question: "How can I subscribe to this service?",
      answer:
        "To subscribe, visit http://mtnfunnybone.com. You can also subscribe via SMS:\nSend 'Day' to 505 for Daily pack\nSend 'Week' to 505 for Weekly pack\nSend 'Month' to 505 for Monthly pack.",
    },
    {
      question: "How can I access the comedy content?",
      answer:
        "Visit http://mtnfunnybone.com where you can preview sample comedy content. Once subscribed, you can enjoy unlimited comedy content.",
    },
    {
      question: "How can I invite my friend to join Funny Bone?",
      answer:
        "To invite a friend, enter their MTN number on the WEB/WAP page. An SMS with the service link will be sent to your friend.",
    },
    {
      question: "Where can I find help/instructions on the service?",
      answer: "Instructions and assistance for the service can be found under the Profile page.",
    },
    {
      question: "Can I engage in live conversations with comedians?",
      answer: "Currently, live interactions with comedians are not available on the service.",
    },
    {
      question: "What are the charges for Funny Bone Service?",
      answer: "Monthly Subscription: K15\nWeekly Subscription: K5\nDaily Subscription: K2",
    },
    {
      question: "How can I unsubscribe from Funny Bone Service?",
      answer:
        "Visit the web page and select the PROFILE option or send:\nSTOPD to 505 for Daily pack\nSTOPW to 505 for Weekly pack\nSTOPM to 505 for Monthly pack.",
    },
    {
      question: "In what cities is this service available?",
      answer: "The service is available to all MTN customers across Zambia.",
    },
  ];
  

  return (
    <>
    <Navbar/>
    <div className={classes.container}>
    <div className={classes.subscribe}>
      <div className={classes.text}>Frequently Asked Questions</div>
    </div>
    <div className={classes.main}>
      <p className={classes.title}>Questions you often ask</p>
      <p className={classes.desc}>We take the funny business seriously.</p>
      <div className={classes.cards}>
      {
        faqs.map((faq, index) => (
          <>
          <Card faq={faq}/>
          </>
        ))
      }
     
      </div>
      </div>
    </div>
    </>
  )
}

export default Faq
